import { z } from "zod";

// Source of truth for the boilerplate's `VITE_*`: typed parsing, fail-loud at
// boot. Default and supported locales are FALLBACKS: if the backend exposes the
// platform manifest (`GET /capabilities`), it wins.
const schema = z.object({
  VITE_API_BASE_URL: z.string().url(),
  VITE_DEFAULT_LOCALE: z.string().default("it-IT"),
  VITE_SUPPORTED_LOCALES: z
    .string()
    .default("it-IT")
    .transform((s) =>
      s
        .split(",")
        .map((x) => x.trim())
        .filter(Boolean),
    ),
  VITE_THEME_DEFAULT_MODE: z.enum(["light", "dark"]).default("light"),
  /** `cookie` requires `AUTH_COOKIE_ENABLED=true` on the BE + CORS with credentials. */
  VITE_AUTH_MODE: z.enum(["bearer", "cookie"]).default("bearer"),
  /**
   * Google Maps key (Maps JavaScript API + Places API) for the address field of legal
   * entities. Optional: empty/absent → plain text fields, no map, no Google call.
   * PUBLIC in the bundle: restrict it by HTTP referrer in the Google console.
   */
  VITE_GOOGLE_MAPS_API_KEY: z
    .string()
    .optional()
    .transform((s) => (s ? s : undefined)),
});

const parsed = schema.safeParse(import.meta.env);
if (!parsed.success) {
  console.error("Invalid env vars for boilerplate:", z.treeifyError(parsed.error));
  throw new Error("Invalid environment configuration — see console for details");
}

export const env = parsed.data;
